module.exports = __webpack_public_path__ + "img/sapins-small.8e14b334.png";